module.exports = __webpack_public_path__ + "media/images/icons/burst-65b2bc8198779215f603f9bc278984b8.svg";